export default __webpack_public_path__ + "static/media/AF.777aa99c.png";